import { Button, Typography } from '@arionbanki/arionui';
import { Circle, Footer, Modal, ProgressBar } from 'components';
import docImage from 'img/doc.png';
import { useSign } from './useSign';

export function Sign() {
	const { config, goBack, isSubmited, t, ...ctx } = useSign();
	return !config.IS_EMPLOYEE_WEB ? null : (
		<ProgressBar page="sign">
			{ctx.infoboxMessage && <Typography TagName="p">{t(ctx.infoboxMessage, 'document_signing')}</Typography>}
			<Typography className="text-secondary" TagName="h3">
				{t('signing_title', 'document_signing')}
			</Typography>
			<Typography TagName="p">{t('signing_subtitle', 'document_signing')}</Typography>
			<div className="card card--white mt-4 mb-4">
				<div className="row">
					<div className="d-none d-md-block col-md-2">
						<img alt="" className="sign-card-img" src={docImage} />
					</div>
					<div className="col-12 col-sm-8 col-md-7 col-xl-5">
						<Typography className="text-secondary" TagName="h6">
							{t('signing_agreement', 'document_signing')}
						</Typography>
						{ctx.state.user.givenName}
					</div>
					<div className="col-12 col-sm-4 col-md-3 col-xl-5 text-end">
						<Button disabled={isSubmited} mode="stroked" onClick={ctx.handleSend}>
							{t('send', 'document_signing')}
						</Button>
						<Button disabled={isSubmited} mode="stroked" onClick={ctx.handlePrint}>
							{t('print', 'document_signing')}
						</Button>
					</div>
				</div>
			</div>
			<div className="card card--grey card--no-shadow mb-4">
				<Typography TagName="h6">
					<Circle>1</Circle>
					{t('signing_p1_title', 'document_signing')}
				</Typography>
				<Typography className="font--16 mb-4" TagName="p">
					{t('signing_p1', 'document_signing')}
				</Typography>
				<Typography TagName="h6">
					<Circle>2</Circle>
					{t('signing_p2_title', 'document_signing')}
				</Typography>
				<Typography className="font--16" TagName="p">
					{t('signing_p2', 'document_signing')}
				</Typography>
			</div>
			<Footer
				handleNext={() => ctx.setIsConfirmModalOpen(true)}
				handlePrev={goBack}
				isDisabled={isSubmited}
				next={t('confirm', 'document_signing')}
				prev={t('back')}
			/>
			<Modal
				background="dim"
				handleClose={() => ctx.setSignedModalMessage('')}
				isOpen={!!ctx.signedModalMessage}
			>
				<Typography TagName="p">{ctx.signedModalMessage}</Typography>
			</Modal>
			<Modal
				background="dim"
				handleClose={() => ctx.setIsConfirmModalOpen(false)}
				isOpen={ctx.isConfirmModalOpen}
			>
				<Typography TagName="p">{t('do_you_confirm', 'document_signing')}</Typography>
				<Button mode="primary" onClick={ctx.handleConfirm}>
					{t('confirm_modal_btn', 'document_signing')}
				</Button>
			</Modal>
		</ProgressBar>
	);
}
